import { UIText3, RadioButtonGroup } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export interface IFilterProps extends React.ComponentProps<typeof RadioButtonGroup> {
  title: string;
}

export const Filter: React.FC<React.PropsWithChildren<IFilterProps>> = props => {
  const { options, onChange, title, value } = props;

  return (
    <div className={styles['filter']}>
      <UIText3>{title}</UIText3>
      <RadioButtonGroup onChange={onChange} options={options} value={value} />
    </div>
  );
};
